import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ReactMarkdown from 'react-markdown'
import * as configcatJs from 'configcat-js'

import {
  Grid,
  Modal,
  Paper,
  Typography
} from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close'

const ModalAlert = () => {
  const classes = useStyles()

  const [configCatLoaded, setConfigCatLoaded] = useState(false)
  const isMobile = window.matchMedia('(max-width: 767px)').matches

  const [isOpen, setIsOpen] = useState(false)
  const [modalText, setModalText] = useState('')

  const {
    NODE_ENV,
    REACT_APP_CONFIG_CAT,
    REACT_APP_CONFIG_CAT_MOBILE
  } = window?.env || {}

  useEffect(() => {
    if (!configCatLoaded && NODE_ENV === 'production' && REACT_APP_CONFIG_CAT !== '#') {
      const configCatClient = configcatJs.createClientWithManualPoll(isMobile ? REACT_APP_CONFIG_CAT_MOBILE : REACT_APP_CONFIG_CAT)

      configCatClient.forceRefresh(async () => {
        const aviso = await configCatClient.getValueAsync('habilitaModalAviso', false)
        const texto = await configCatClient.getValueAsync('textoModal', '')

        setIsOpen(aviso)
        setModalText(texto)
        setConfigCatLoaded(true)
      })
    }
  }, [configCatLoaded, NODE_ENV, REACT_APP_CONFIG_CAT, REACT_APP_CONFIG_CAT_MOBILE, isMobile])

  const components = {
    h2: ({ node, children }) => <Grid item><Typography variant='h5'>{children}</Typography></Grid>,
    p: ({ node, children }) => <Grid item><Typography variant='body1'>{children}</Typography></Grid>
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className={classes.modal}
    >
      <Paper className={classes.modalPaper}>
        <CloseIcon onClick={() => setIsOpen(false)} className={classes.modalClose} />
        <Grid container direction='column' wrap='nowrap' spacing={4}>
          <ReactMarkdown components={components}>
            {modalText}
          </ReactMarkdown>
        </Grid>
      </Paper>
    </Modal>
  )
}

const useStyles = makeStyles(theme => ({
  modal: {
    zIndex: '1400 !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalPaper: {
    minWidth: 320,
    width: 750,
    maxWidth: '100%',
    maxHeight: 'calc(100% - 30px)',
    overflowY: 'auto',
    outline: 'none',
    padding: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative'
  },
  modalClose: {
    position: 'absolute',
    top: theme.spacing(6),
    right: theme.spacing(6),
    cursor: 'pointer'
  }
}))

export default ModalAlert
